import { USER_SERVICE_ORIGIN } from "../props";

export function useUserServiceURL() {
  return new URL("/", USER_SERVICE_ORIGIN).origin;
}
